module.exports = __webpack_public_path__ + "static/media/team_image.9dd3eaa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/team_image.png
// module id = 222
// module chunks = 1